// extracted by mini-css-extract-plugin
export default {"legalPage":"legal_legalPage__NECJ1","subtitle":"legal_subtitle__GY-6S","lastUpdated":"legal_lastUpdated__WhzXd"};